import script from "./TraitShopTopActions.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopTopActions.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopTopActions.vue?vue&type=style&index=0&id=a3fdafcc&lang=scss"

const __exports__ = script;

export default __exports__